import React from "react";
import "./videoProfile.scss";

export const VideoProfile = ({ handelClose }) => {
  // Complete jobseeker's profile tutorial Video
  return (
    <>
      <h2 className="video_screen_title">Tutorial for Profile completion</h2>
      <iframe
        width="100%"
        height="405"
        src="https://www.youtube.com/embed/SEyKIyAdk8c"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </>
  );
};